export default __webpack_public_path__ + "static/media/CPF Logo New.7e4f3c8a.jpg";